import React from "react";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    Tooltip,
    LinearScale,
    CategoryScale,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(LineElement, PointElement, Tooltip, LinearScale, CategoryScale);

const CustomChart = () => {
    const data = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May"],
        datasets: [
            {
                data: [10000, 15000, 17384, 20000, 25000],
                borderColor: "#000000", // Line color
                borderWidth: 2, // Line width
                backgroundColor: "transparent",
                pointBackgroundColor: "#000000", // Circle color
                pointBorderColor: "#000000",
                pointBorderWidth: 2, // Circle border width
                pointRadius: 5, // Circle size (radius = 5px -> 10px by 10px)
                pointHoverRadius: 7, // Circle size on hover
                tension: 0.3, // Curve for the line
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            tooltip: {
                backgroundColor: "#000000", // Tooltip background
                titleColor: "#FFFFFF", // Tooltip text color
                callbacks: {
                    label: function (context) {
                        return `$ ${context.raw.toLocaleString()}`; // Format the tooltip value
                    },
                },
                displayColors: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // Remove grid lines for the x-axis
                },
                ticks: {
                    display: false, // Hide x-axis labels
                },
                border: {
                    display: false, // Remove x-axis border
                },
            },
            y: {
                grid: {
                    display: false, // Remove grid lines for the y-axis
                },
                ticks: {
                    display: false, // Hide y-axis labels
                },
                border: {
                    display: false, // Remove y-axis border
                },
            },
        },
        layout: {
            padding: {
                left: 10, // Add space to the left
                bottom: 10, // Add space to the bottom
            },
        },
    };


    return (
        <div className="line-chart">
            <Line data={data} options={options} />
        </div>
    );
};

export default CustomChart;
